'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var PenOutline = function PenOutline(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 15 15' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M13.7 4.624L12.306 6.02 8.97 2.679l1.394-1.396a1.183 1.183 0 0 1 1.634 0L13.7 2.987a1.16 1.16 0 0 1 0 1.637zM5.974 12.36l-1.328-1.33 3.51-3.513-.681-.682-3.51 3.514-1.327-1.33 5.65-5.658 3.337 3.34-5.651 5.659zm-4.548 1.214l.828-3.575 2.742 2.745-3.57.83zM14.38 2.306L12.679.6c-.801-.801-2.197-.8-2.996 0l-8.17 8.18L0 15l6.21-1.514 8.17-8.18a2.126 2.126 0 0 0 0-3z',
          fill: 'currentColor' })
      )
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = PenOutline;